module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Buried-Knights-Templar-1.1612d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Buried-Knights-Templar-1.jpg
// module id = CeVS
// module chunks = 0